import { Directive, Attribute, Input } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS, ValidationErrors } from '@angular/forms';

@Directive({
	selector: '[appValidateRange]',
	providers: [{
		provide: NG_VALIDATORS,
		useExisting: ValidateRangeDirective,
		multi: true
	}]
})
export class ValidateRangeDirective implements Validator {

	@Input('appValidateRange') public validateRange: string;

	constructor(
	) { }

	validate(c: AbstractControl): ValidationErrors {
		if (!this.validateRange) {
			return null;
		}
		const v = c.value;
		if (v || v === 0) {
			const num = Number(v);
			if (isNaN(num)) {
				return {
					invalid: true
				};
			}
			const range = this.validateRange.trim();
			const isMinOpen = range[0] === '(';
			const isMaxOpen = range[range.length - 1] === ')';
			const sepIndex = range.indexOf(','); // separator index
			const min = Number(range.substring(1, sepIndex -1));
			const max = Number(range.substring(sepIndex + 1, range.length - 1));
			if (!isNaN(min) && !isNaN(max)) {
				if (num < min || (isMinOpen && num <= min)) {
					return {
						exceedRange: 'min'
					}
				} else if (num > max || (isMaxOpen && num >= max)) {
					return {
						exceedRange: 'max'
					}
				}
			}
		}
	}

}
